export default "__VITE_ASSET__DrB2nDRC__"